(function () {
  if (window.__rySmooth) return;
  window.__rySmooth = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  function go() {
    var hdr = document.querySelector('[data-ry-hdr]');
    if (hdr && hdr.getAttribute('data-smooth') === 'false') return;
    var sc = document.createElement('script');
    sc.src = 'https://cdn.jsdelivr.net/npm/lenis@1.3.11/dist/lenis.min.js';
    sc.async = true;
    sc.onload = function () {
      if (!window.Lenis) return;
      var off = hdr ? -(hdr.offsetHeight + 16) : -80;
      var lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 1, anchors: { offset: off }, autoRaf: true });
      window.ryLenis = lenis;
      var root = document.documentElement;
      new MutationObserver(function () {
        if (root.style.overflow === 'hidden') lenis.stop(); else lenis.start();
      }).observe(root, { attributes: true, attributeFilter: ['style'] });
    };
    document.head.appendChild(sc);
  }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();